import type {
  AuthStatusEnum,
  CommonStatus,
  ElEleTypeEnum,
  PayTypeEnum,
} from "@/types/enums";
import type { SanFangEnum, SanFangItemType } from "@/types/sanFang";
import type { UserRoleEleType } from "@/types/UserType";
import type { YouzanPapersType } from "@/types/youZan/papersType";

export const PayTypeList: { label: string; value: PayTypeEnum }[] = [
  {
    label: "微信",
    value: "wechat_h5",
  },
  {
    label: "微信小程序",
    value: "wechat_mp",
  },
  {
    label: "支付宝",
    value: "alipay_h5",
  },
];

export function getPayTypeLabel(value: string): string {
  return PayTypeList.find((v) => v.value == value)?.label ?? "未知";
}

export const PayMchTypeList = [
  {
    label: "微信",
    value: "wechat",
  },
  {
    label: "支付宝",
    value: "alipay",
  },
];

export function getPayMchTypeLabel(value: string): string {
  return PayMchTypeList.find((v) => v.value == value)?.label ?? "未知";
}

export const AuthStatusList: {
  label: string;
  value: AuthStatusEnum;
  tag_type: ElEleTypeEnum;
}[] = [
  {
    label: "未认证",
    value: "waitInfo",
    tag_type: "info",
  },
  {
    label: "等待审核",
    value: "waitAudit",
    tag_type: "primary",
  },
  {
    label: "认证失败",
    value: "reInfo",
    tag_type: "warning",
  },
  {
    label: "认证通过",
    value: "pass",
    tag_type: "success",
  },
];

export const UserRoleList: UserRoleEleType[] = [
  {
    label: "超级管理员",
    value: "superAdmin",
    tag_type: "primary",
  },
  {
    label: "管理员",
    value: "admin",
    tag_type: "success",
  },
  {
    label: "用户",
    value: "user",
    tag_type: "info",
  },
];

// 有赞
// 是否收款
export const YouZanPaymentBusinessType = [
  {
    label: "收款",
    value: 0,
  },
  {
    label: "不收款",
    value: 1,
  },
];
// 主体认证类型
export const YouZanPrincipalCertType = [
  {
    label: "个人",
    value: 1,
  },
  {
    label: "企业",
    value: 2,
  },
  {
    label: "个体工商户",
    value: 3,
  },
];
// 有赞法人身份证件类型列表
export const YouzanPapersTypeList: YouzanPapersType[] = [
  {
    label: "大陆身份证",
    value: 1,
  },
  {
    label: "港澳台（身份证、居民通行证",
    value: 2,
  },
  {
    label: "护照（限境外人士）",
    value: 3,
  },
  {
    label: "来往内地通行证（中国香港居民）",
    value: 4,
  },
  {
    label: "来往内地通行证（中国澳门居民）",
    value: 5,
  },
  {
    label: "来往内地通行证（中国台湾居民）",
    value: 6,
  },
];

export const sanFangList: SanFangItemType[] = [
  {
    label: "有赞",
    value: "youzan",
  },
  {
    label: "银盛",
    value: "ysepay",
  },
];

export function getSanFangLabelByValue(v: SanFangEnum | string): string {
  return sanFangList.find((item) => item.value == v)?.label ?? "未知";
}

export const YouzanOpenPaySignTypeList = [
  {
    label: "微信公众号",
    value: "WX_PUBLIC_ACCOUNT",
  },
  {
    label: "微信小程序",
    value: "WX_APPLET",
  },
  {
    label: "支付宝JS",
    value: "ALIPAY_JS",
  },
];

export function getYouzanOpenPaySignTypeLabel(value: string): string {
  return (
    YouzanOpenPaySignTypeList.find((v) => v.value == value)?.label ?? "未知"
  );
}

export const CommonStatusList: { label: string; value: CommonStatus }[] = [
  {
    label: "成功",
    value: "SUCCESS",
  },
  {
    label: "失败",
    value: "FAIL",
  },
  {
    label: "处理中",
    value: "PROCESSING",
  },
];

export function getCommonStatusByValue(status: CommonStatus): string {
  return CommonStatusList.find((v) => v.value == status)?.label ?? "未知";
}

// 有赞图片大小不能超过1m
export const YouzanImgSizeLimit = 1024 * 1000;

export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH-mm-ss";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

// 银盛商户类型
export const YsepayMercTypeList: { label: string; value: string }[] = [
  {
    label: "小微",
    value: "2",
  },
  {
    label: "个体",
    value: "3",
  },
  {
    label: "企业",
    value: "4",
  },
  {
    label: "社会组织",
    value: "5",
  },
  {
    label: "事业单位",
    value: "6",
  },
  {
    label: "政府机关",
    value: "7",
  },
];

export function getYsepayMercTypeByValue(value: string): string {
  return YsepayMercTypeList.find((v) => v.value == value)?.label ?? "未知";
}

// 银盛图片大小不能超过2M
export const YsepayImgSizeLimit = 1024 * 1024 * 2;
